module.exports = __webpack_public_path__ + "static/4-7d2a0fc891ea9a234dbdecfc9bb3d897.jpg";